export const ContentStyle = {
  dialogContent: {
    width: '600px',
    height: '380px',
  },
  input: {
    marginRight: '10px',
  },
  container: {
    marginTop: '16px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  image: {
    marginRight: '10px',
    cursor: 'pointer',
  },
} as const;
